<template>
    <div>
        <div class="modal-button block-but">
             <el-button
                type="text"
                @click="dialogTableVisible = true"
                >
                Добавить
                </el-button>
        </div>
        <el-dialog title="Создание контакта" :visible.sync="dialogTableVisible">
            <el-form :model="form" :rules="rules" ref="form" label-position="left" label-width="165px">
                <el-form-item label="Должность (служба)" prop="position">
                    <el-input size="small" v-model="form.position"></el-input>
                </el-form-item>
                <el-form-item label="ФИО" prop="contactName">
                    <el-input size="small" v-model="form.contactName"></el-input>
                </el-form-item>
                <el-form-item label="Телефон" prop="phone">
                    <el-input size="small" v-model="form.phone" v-mask="'+7 ### ### ## ##'"></el-input>
                </el-form-item>
                <el-form-item label="Комментарий" prop="description">
                    <el-input size="small" v-model="form.description"></el-input>
                </el-form-item>
                <el-form-item label=" Часы приема" prop="receptionHours">
                    <el-input size="small" v-model="form.receptionHours"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                    <el-button
                        size="mini"
                        @click="dialogTableVisible = false"
                        >
                        Отменить
                    </el-button>

                    <el-button
                        size="mini"
                        type="primary"
                        @click="orgCreateContact"
                        :loading="loading"
                        >
                        Добавить
                    </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            dialogTableVisible: false,
            form: {
                position: '',
                contactName: '',
                phone: '+7',
                description: '',
                receptionHours: ''
            },
            rules: {
				position: [
					{ required: true, message: 'Поле не должно быть пустым', trigger: 'blur' },
				],
				contactName: [
					{ message: 'Поле не должно быть пустым', trigger: 'blur' },
				],
				phone: [
					{ required: true, message: 'Поле не должно быть пустым', trigger: 'blur' },
				],
            }
        }
    },
    props: {

    },
    methods: {
        async orgCreateContact() {
            this.$refs.form.validate(async (valid) => {
                if(valid) {
                    this.loading = true
                    try {
                        await this.$store.dispatch('organizationUpdateOrCreateContact', {
                            edit: false,
                            form: this.form
                        })
                        this.$refs.form.resetFields()
                        this.dialogTableVisible = false
                    } catch(e) {
                        this.$ErrorsMod(e)
                    }
                    this.loading = false
                } else {
                    return false;
                }
            })


        }
    },
    watch: {
        dialogTableVisible(value) {
            !value ? this.$refs.form.resetFields() : false
        }
    }
}
</script>

<style scoped>
    .block-but .el-button {
        padding: 0px 20px !important;
    }
</style>